import { createTheme } from '@material-ui/core/styles'

export const autocompleteTheme = createTheme({
  overrides: {
    MuiFormControl: {
      root: {
        margin: 0,
      },
    },
    MuiAutocomplete: {
      inputRoot: {
        '&&[class*="MuiOutlinedInput-root"] $input': {
          padding: 0,
          backgroundColor: 'white',
          fontSize: '14px',
        },
      },
      listbox: {
        backgroundColor: 'white',
        border: 'unset',
        borderRadius: 'unset',
      },
      option: {
        backgroundColor: 'white',
        '&[data-focus="true"]': {
          backgroundColor: '#F2F2F2',
        },
        '&[aria-selected="true"]': {
          backgroundColor: '#fff',
        },
      },
    },
  },
})

export const autocompletePerspectiveTheme = createTheme({
  overrides: {
    MuiFormControl: {
      root: {
        margin: 0,
      },
    },
    MuiAutocomplete: {
      inputRoot: {
        '&&[class*="MuiOutlinedInput-root"] $input': {
          padding: 0,
          backgroundColor: 'white',
        },
      },
      listbox: {
        backgroundColor: 'white',
        border: '1px solid #4099ff',
        borderRadius: '2px',
      },
      option: {
        backgroundColor: 'white',
        '&[data-focus="true"]': {
          backgroundColor: '#F2F2F2',
        },
        '&[aria-selected="true"]': {
          backgroundColor: '#E5E5E5',
        },
      },
    },
  },
})

export const tableTheme = createTheme({
  overrides: {
    MuiMenu: {
      paper: {
        backgroundColor: 'white',
      },
    },
    MuiPaper: {
      root: {
        backgroundColor: 'white',
        maxWidth: '100%',
        '& [class*="Component-horizontalScrollContainer-"]': {
          backgroundColor: 'white',
          display: 'inline-grid',
          width: '100%',
          maxHeight: '480px',
          overflowY: 'auto',
        },
      },
    },
    MuiTableRow: {
      root: {
        '&:nth-of-type(odd)': {
          backgroundColor: '#fff',
          color: '#000 !important',
          '& [class*="MuiTableCell-body-"]': {
            color: '#000 !important',
          },
        },
        '&:nth-of-type(even)': {
          backgroundColor: '#fff',
          color: '#000 !important',
          '& [class*="MuiTableCell-body-"]': {
            color: '#000 !important',
          },
        },
        '& [class*="ForwardRef(MTableHeaderRef)-header-"]': {
          backgroundColor: 'white',
        },
      },
    },
    MuiTableHead: {
      root: {
        '& [class*="MuiTableRow-"]': {
          backgroundColor: '#fff !important',
        },
        '& [class*=" MuiTableCell-head"]': {
          color: '#000 !important',
        },
      },
    },
    MuiTableFooter: {
      root: {
        '& [class*="MuiTableRow-"]': {
          backgroundColor: '#fff !important',
          color: '#000 !important',
        },
      },
    },
    MuiList: {
      root: {
        backgroundColor: '#fff',
      },
    },
  },
})

export const pickerTheme = createTheme({
  components: {
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          margin: '0',
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          margin: '0 !important',
        },
      },
    },
  },
})
